/* List of Redux constants */
export const AUTH_USER_SET_LOADING = '@auth-user/set-loading';
export const AUTH_USER_SET_DATA = '@auth-user/set-data';
export const AUTH_USER_RESET_DATA = '@auth-user/reset-data';
export const AUTH_USER_SET_ERROR = '@auth-user/set-error';
export const AUTH_USER_SET_SIGNED_OUT_EXPLICITLY =
  '@auth-user/set-signed-out-explicitly';

/* List of Sagas constants */
export const AUTH_USER_INIT = '@auth-user/init';
export const AUTH_USER_SIGN_IN = '@auth-user/sign-in';
export const AUTH_USER_SIGN_OUT = '@auth-user/sign-out';
export const AUTH_USER_SET_USER_FROM_AUTH_DATA =
  '@auth-user/set-user-auth-data';
export const AUTH_USER_IMPERSONATE = '@auth-user/impersonate';
export const AUTH_USER_SYNC_WITH_AUTH_TOKENS =
  '@auth-user/sync-with-auth-tokens';



// WEBPACK FOOTER //
// ./src/actions/auth-user/types.js